import { VisibilityToggle } from "@/common/components/buttons/visibility-toggle/visibility-toggle";
import { useToggle } from "@/shared/hooks/useToggle";

import { TextField, TextFieldBase } from "../../text-field/TextField";
import { useSubmitFirstField } from "../../useSubmitFirstField";

type PasswordFieldBaseProps = Omit<
  React.ComponentProps<typeof TextFieldBase>,
  "icon" | "type"
>;

const PasswordFieldBase = (
  props: PasswordFieldBaseProps,
): React.ReactElement => {
  const { on, toggle } = useToggle();

  return (
    <TextFieldBase
      {...props}
      type={on ? "text" : "password"}
      icon={
        <VisibilityToggle
          data-testid={`${props.name}-visibility-toggle`}
          isVisible={on}
          onClick={toggle}
        />
      }
    />
  );
};

type PasswordFieldProps = Omit<
  React.ComponentProps<typeof TextField>,
  "icon" | "type"
>;

const PasswordField = ({
  name,
  onValueChange,
  ...props
}: PasswordFieldProps): React.ReactElement => {
  const { error, handleBlur, handleChange, value } =
    useSubmitFirstField<string>(name);

  const handleFieldChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    handleChange(e);
    onValueChange?.(e.target.value);
  };

  return (
    <PasswordFieldBase
      {...props}
      error={error}
      name={name}
      onBlur={handleBlur}
      onChange={handleFieldChange}
      value={value}
    />
  );
};

export {
  PasswordField,
  PasswordFieldBase,
  type PasswordFieldBaseProps,
  type PasswordFieldProps,
};
